import { render, staticRenderFns } from "./Langs.vue?vue&type=template&id=02d8852d&"
import script from "./Langs.vue?vue&type=script&lang=js&"
export * from "./Langs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports